/**
 * Strix brand mark — owl logo + product name.
 * Replaces the old W7 "w"+"7" wordmark on all console surfaces.
 */

export const STRIX_LOGO_SRC = '/brand/strix-logo.png'
export const STRIX_BRAND_NAME = 'Strix'
/** @deprecated Product suffix removed from the mark — kept empty for old imports. */
export const STRIX_PRODUCT_LABEL = ''

export function StrixMark({
  className,
  size = 36,
  suffix,
  showName = true,
}: {
  className?: string
  size?: number
  /** Optional secondary label beside the brand name. Prefer omitting. */
  suffix?: string
  /** When false, logo only (collapsed rail). */
  showName?: boolean
}) {
  return (
    <span
      className={['strix-mark', 'w7-logo', className].filter(Boolean).join(' ')}
      style={{ ['--strix-mark-size' as string]: `${size}px` }}
      aria-hidden={suffix || showName ? undefined : true}
    >
      <img
        className="strix-mark-logo"
        src={STRIX_LOGO_SRC}
        alt=""
        width={size}
        height={size}
        decoding="async"
      />
      {showName ? <span className="strix-mark-name">{STRIX_BRAND_NAME}</span> : null}
      {suffix ? <em>{suffix}</em> : null}
    </span>
  )
}

/** @deprecated Use StrixMark — kept so older imports resolve during rename. */
export const W7Mark = StrixMark
